import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  connect() {
    this.target = this.element.getAttribute("data-target");
    this.src = this.element.getAttribute("data-src");
  }

  reload() {
    document.querySelectorAll(`turbo-frame#${this.target}`).forEach((frame) => {
      frame.src = this.src;
      frame.reload();
    });
  }
}
